import { Component, OnInit, Inject } from '@angular/core';
import { CommonDataModel } from '../../common-data-model';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { VehiclesService } from 'src/app/vehicles/vehicles.service';
import { ToastrService } from 'ngx-toastr';
import { AddAddressComponent } from '../../add-address/add-address.component';
import { CommonService } from 'src/app-core/services/common.service';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-notes-form',
  templateUrl: './notes-form.component.html',
  styleUrls: ['./notes-form.component.scss']
})
export class NotesFormComponent implements OnInit {

  notesDataModel = new CommonDataModel();
  notesFormModel = this.notesDataModel.notesFormModel;
  isFormLoading = false;
  vehicleNoteId: string;
  title: string;

  constructor(
    private commonService: CommonService,
    private toastr: ToastrService,
    private router: Router,
    public dialogRef: MatDialogRef<AddAddressComponent>,
    @Inject(MAT_DIALOG_DATA) vehicle?: any) {
    this.notesFormModel.vehicleId = vehicle.vehicleId;
    this.vehicleNoteId = vehicle.vehicleNoteId;
  }

  ngOnInit() {
    if (this.router.url.indexOf('customer-details') !== -1) {
      this.title = 'Customer';
    } else if (this.router.url.indexOf('lead-details') !== -1) {
      this.title = 'Lead';
    } else {
      this.title = 'Vehicle';
    }
    this.getNoteDetails();
  }

  getNoteDetails(): void {
    if (this.vehicleNoteId) {
      this.isFormLoading = true;
      this.commonService.getVehicleNotes(this.vehicleNoteId)
      .pipe(finalize(() => (this.isFormLoading = false)))
      .subscribe(response => {
        this.isFormLoading = false;
        this.notesFormModel.notes = response.data.vehicleNotes;
      });
    }
  }

  onSubmit(): void {
    if (this.router.url.indexOf('customer-details') !== -1) {
      this.onSaveAccountNote();
    } else if (this.router.url.indexOf('lead-details') !== -1) {
      this.onSaveAccountNote();
    } else {
      this.onSaveVehicleNote();
    }

  }

  onSaveAccountNote() {
    const noteData = {
      accountId: this.notesFormModel.vehicleId,
      notes: this.notesFormModel.notes
    };
    this.isFormLoading = true;
    this.commonService.createAccountNote(noteData)
    .pipe(finalize(() => (this.isFormLoading = false)))
    .subscribe(response => {
      this.isFormLoading = false;
      if (response.isSuccess) {
        this.toastr.success(response.errors);
        this.onClose(true);
      } else {
        this.toastr.error(response.errors || 'Something Went Wrong Please Re-try', 'Error!');
      }
    });
  }

  onSaveVehicleNote() {
    this.isFormLoading = true;
    this.commonService.createNotes(this.notesFormModel).subscribe(res => {
      this.isFormLoading = false;
      this.toastr.success('Vehicle Notes Added successfully.');
      this.onClose(true);
    });
  }

  onClose(isSuccess?: boolean): void {
    this.dialogRef.close(isSuccess);
  }
}
